<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line" style="margin: 10px 0;">
        <div class="textBox" style="margin-right: 20px;">
          <b class="red">*</b>
          <span class="line-text">标题：</span>
        </div>
        <el-input v-model="title" size="small" style="width: 280px;" />
      </div>

      <div class="form-line" style="margin: 10px 0;">
        <div class="textBox" style="margin-right: 20px;">
          <b class="red">*</b>
          <span class="line-text">获取时间：</span>
        </div>
        <el-input v-model="obtainTime" size="small" style="width: 280px;" />
      </div>

      <div class="form-line" style="margin: 10px 0 0 0">
        <div class="textBox" style="margin-right: 18px;">
          <span class="line-text">图片：</span>
        </div>
        <!--<upload-img-list @getImgList="getImgList"  />-->
        <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
               @change="upData2" style="display: none" />
        <div>
          <a class="newly2" @click="upImg2" v-if="!pic">
            <span><i class="el-icon-plus"></i></span>
            <span>点击上传</span>
          </a>
          <a class="upload2" @click="upImg2" v-if="pic">
            <img :src="pic" id="packBg" />
            <b>重新上传</b>
          </a>
        </div>
      </div>

      <div class="form-line" style="margin: 10px 0;">
        <div class="textBox" style="margin-right: 20px;">
          <!--<b class="red">*</b>-->
          <span class="line-text">描述：</span>
        </div>
        <el-input v-model="descrpition" type="textarea" :rows="5" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" value="确定" />
        <button-cancel @cancel="cancel" value="返回" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../../../utils/toBase64'
  import $ from 'jquery'
  import {bus} from '../../../../../utils/bus'
  import {api} from '../../../../api/Summary'
  import {nError, nSuccess} from '../../../../../utils/notice'
  import {errorHandler} from '../../../../../utils/errorHandler'
  import UploadImgList from '../../../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'modify-honor-qualification',
    data () {
      return {
        breadcrumb: [{
          value: '信息发布',
          name: 'group-profile-info'
        }, {
          value: '荣誉资质'
        }],
        mainTitle: '修改荣誉资质',
        subheading: '',
        currentCode: '',
        title: '',
        obtainTime: '',
        descrpition: '',
        pic: '',

        pictureBase64: '',
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getGroupHonorByCode()
    },
    methods: {
      getGroupHonorByCode () {
        this.$axios.post(`${api.getGroupHonorByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.title = data.title
              this.guideMap = data.guideMap

              this.url = data.url
            }
          })
          .catch(errorHandler('查询失败'))
      },
      toManagementPage () {
        this.$router.push({
          name: 'upper-information-honor-qualification-manage'
        })
      },
      getImgList (imageList, base64List) {
        this.imageList = imageList
        this.base64List = base64List
      },
      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadGuidedGraph').files[0]
        console.log(file)
        if (file.size > 1024 * 1024) {
          nError('上传图片不能大于1M')
          return false
        }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.pictureBase64 = src
          that.uploadPicture()
        }
      },
      upImg2: function () {
        document.getElementById('#uploadBackgroundImg')
        $('#uploadGuidedGraph')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },

      // 上传图片
      uploadPicture () {
        this.$axios.post(api.uploadImg, {
          picData: this.pictureBase64
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.guideMap = res.data.data
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
      },

      confirm () {
        if (!this.title) {
          nError('请输入标题')
          return false
        }
        if (!this.obtainTime) {
          nError('请输入获取时间')
          return false
        }
        let reqData = {
          code: this.currentCode,
          title: this.title,
          obtainTime: this.obtainTime,
          descrpition: this.descrpition,
          pic: this.pic,
        }
        this.$axios.post(api.updateGroupHonor, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 80px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 160px;
    height: 90px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    border-radius: 5px;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 50px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 30px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 160px;
    height: 90px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    border-radius: 5px;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/InformationDelivery/HonorQualification/ModifyHonorQualification.vue